import { PROVIDER_TYPE } from 'utils/enums';

export const PROVIDER_SORT_ORDER = [PROVIDER_TYPE.KVD, PROVIDER_TYPE.KTS, PROVIDER_TYPE.HCS, PROVIDER_TYPE.KVBO];

export const REPORT_PROVIDER_SORT_ORDER = [...PROVIDER_SORT_ORDER, PROVIDER_TYPE.HEZ, PROVIDER_TYPE.NAFTOGAS];
